import { t } from '@lingui/macro';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { ROLE_NAMES } from '../users/UserConstants';
import {
    ACTIVE_DIRECTORY_GROUP_LABEL,
    ASSOCIATED_ROLE_FIELD,
    GROUP_NAME_FIELD,
    SAML_GROUP_LABEL,
} from './SsoAdminConstants';

export function getGroupAssociationColumns(isActiveDirectory) {
    const groupTitle = isActiveDirectory ? ACTIVE_DIRECTORY_GROUP_LABEL : SAML_GROUP_LABEL;

    return [
        {
            type: COLUMN_TYPES.TEXT,
            title: groupTitle,
            sortable: false,
            mapping: GROUP_NAME_FIELD,
            width: 200,
        },
        {
            type: COLUMN_TYPES.TEXT,
            title: t`nGeniusPULSE Role`,
            sortable: false,
            mapping: ASSOCIATED_ROLE_FIELD,
            formatter: (role) => ROLE_NAMES[role],
            width: 200,
        },
    ];
}

export function getLdapDefaults() {
    return {
        secure: false,
        anonymous: false,
        enabled: false,
        offlineLoginEnabled: false,
        userSearchFilter: '({{userUsernameAttr}}={{username}})',
        userSearchScope: 'sub',
        userUsernameAttr: 'sAMAccountName',
        userFirstNameAttr: 'givenName',
        userLastNameAttr: 'sn',
        userEmailAddressAttr: 'mail',
        groupSearchBase: '{{userSearchBase}}',
        groupSearchScope: 'sub',
        groupSearchFilter: '({{groupUserMembershipAttr}}={{userDN}})',
        groupNameAttr: 'cn',
        groupUserMembershipAttr: 'member',
        tlsRejectUnauthorized: false,
        defaultRole: 'user',
        groupRoleAssociations: [],
    };
}

export function getSamlDefaults() {
    return {
        enabled: false,
        userUsernameAttr: 'email',
        userEmailAddressAttr: 'email',
        groupUserMembershipAttr: 'memberOf',
        defaultRole: 'user',
        groupRoleAssociations: [],
    };
}

export function getCacDefaults() {
    return {
        enabled: false,
        certsInstalled: false,
    };
}

export function getCacLdapDefaults() {
    return {
        certsInstalled: false,
        secure: false,
        anonymous: false,
        enabled: false,
        offlineLoginEnabled: false,
        userSearchFilter: '({{userUsernameAttr}}={{username}})',
        userSearchScope: 'sub',
        userUsernameAttr: 'sAMAccountName',
        userFirstNameAttr: 'givenName',
        userLastNameAttr: 'sn',
        userEmailAddressAttr: 'mail',
        groupSearchBase: '{{userSearchBase}}',
        groupSearchScope: 'sub',
        groupSearchFilter: '({{groupUserMembershipAttr}}={{userDN}})',
        groupNameAttr: 'cn',
        groupUserMembershipAttr: 'member',
        tlsRejectUnauthorized: false,
        defaultRole: 'user',
        groupRoleAssociations: [],
        inexactMatch: false,
        revocation: {
            method: 'none',
        },
    };
}
